import { styled, Typography, Box, Button, TextField } from "@mui/material";
import { keyframes } from "@mui/system";
import BackgroundImage from "../Assests/backgroundImage.jpg";

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  backdropFilter: "blur(8px)",
  background: `linear-gradient(135deg, rgba(0, 0, 0, 0.5) 50%, rgba(255, 182, 193, 0.6) 100%), url(${BackgroundImage}) no-repeat center center fixed`,
  backgroundSize: "cover",
}));

export const Form = styled("form")({
  width: "100%",
  maxWidth: "420px",
  padding: "40px",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  borderRadius: "16px",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
  animation: `${fadeIn} 1s ease-out`,
});

export const IconButtonWrapper = styled(Box)({
  textAlign: "center",
});

export const Title = styled(Typography)({
  fontSize: "2.5rem",
  fontWeight: "700",
  color: "#333",
  marginBottom: "25px",
  textTransform: "uppercase",
  letterSpacing: "2px",
});

export const StyledTextField = styled(TextField)({
  backgroundColor: "#f4f6f9",
  border: "2px solid #ddd",
  borderRadius: "8px",
  padding: "15px",
  fontSize: "1rem",
  width: "100%",
  marginBottom: "15px",
  transition: "border 0.3s ease",
  "&:focus": {
    outline: "none",
  },
});

export const SubmitButton = styled(Button)({
  backgroundColor: "#3f51b5",
  color: "white",
  fontSize: "1.1rem",
  padding: "12px 0",
  marginTop: "20px",
  borderRadius: "8px",
  width: "100%",
  cursor: "pointer",
  transition: "background-color 0.3s ease, transform 0.2s ease",
  "&:hover": {
    backgroundColor: "#303f9f",
    transform: "scale(1.05)",
  },
});

export const HelperText = styled("p")({
  fontSize: "0.9rem",
  color: "#f44336",
  marginBottom: "15px",
});
